import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { formatValue } from '../../helpers/utils';
import {
  CommentContainer,
  HeaderConteiner,
  CommentRaiting,
  DateContainer,
  CustomerComment,
  Recomended,
  RecomendedImg,
  StarImg
} from './styles';
import CommentStar from '../../assets/icons/commentStar.svg';
import RecommendedIcon from '../../assets/icons/recommended.svg';
import NeutralCalificationIcon from '../../assets/icons/neutralCalification.svg';
import NotRecommendedIcon from '../../assets/icons/notRecommended.svg';

const Comment = ({ customerComment, keyId }) => {
  const { t } = useTranslation();
  const { averageScore, comment, recommended, date } = customerComment;

  const recomendedComment = ['4', '5'].includes(recommended);
  const neutralComment = ['3'].includes(recommended);
  const notRecomendedComment = ['1', '2'].includes(recommended);

  return (
    <>
      <CommentContainer data-panel={`comment-container-${keyId}`}>
        <HeaderConteiner data-panel={`comment-container-header-${keyId}`}>
          <CommentRaiting>
            <StarImg src={CommentStar} data-panel={`comment-container-ratings-stars-${keyId}`} alt='star' />
            {formatValue(averageScore)}
          </CommentRaiting>
          <DateContainer data-panel={`comment-container-date-${keyId}`}>
            {moment(date).format('DD MMM YYYY')}
          </DateContainer>
        </HeaderConteiner>
        <CustomerComment data-panel={`comment-container-comment-${keyId}`}>{comment}</CustomerComment>

        <Recomended recommended={recomendedComment} neutralComment={neutralComment}>
          {recomendedComment && (
            <RecomendedImg
              data-panel={`comment-container-recomended-img-${keyId}`}
              src={RecommendedIcon}
              alt='recomendado'
            />
          )}
          {neutralComment && (
            <RecomendedImg
              data-panel={`comment-container-recomended-img-${keyId}`}
              src={NeutralCalificationIcon}
              alt='Neutral comment'
            />
          )}
          {notRecomendedComment && (
            <RecomendedImg
              data-panel={`comment-container-recomended-img-${keyId}`}
              src={NotRecommendedIcon}
              alt='No recomendado'
            />
          )}
          {recomendedComment && t('panel.estadisticas.ratings.recommended')}
          {neutralComment && t('panel.estadisticas.ratings.neutralRecommended')}
          {notRecomendedComment && t('panel.estadisticas.ratings.notRecommended')}
        </Recomended>
      </CommentContainer>
    </>
  );
};

export default Comment;
